import {
  REQUEST_UMC_ROOM_LIST,
  REQUEST_UMC_ROOM_LIST_FAIL,
  REQUEST_UMC_ROOM_LIST_SUCCESS,
  SELECTED_ROOM_AND_DOCTOR,
  HIDE_MODAL_PICK_TIME,
  SELECTED_ROOM_AND_DOCTOR_SUCCESS,
  SELECTED_ROOM_AND_DOCTOR_FAIL,
  SELECTED_TIME,
  SELECTED_BHYT,
  SUBMIT_DOCTOR_AND_TIME,
  RESET_REDIRECT_TO_CONFIRM_INFO,
  REMOVE_DOCTOR_AND_TIME,
  SHOW_MESSAGE_ERROR_CHOOSE_TIME_AND_BHYT,
  REQUEST_TIME_SLOT_IN_DOCTOR_FLOW,
  GET_DOCTOR_TIME_SLOT_REQUEST,
  GET_DOCTOR_TIME_SLOT_SUCCESS,
  GET_DOCTOR_TIME_SLOT_FAILURE,
  RESET_ALL_PROPS_DOCTOR_AND_TIME,
  RESET_SELECTED_TIME_AND_BHYT,
  RESET_SELECTED_DOCTOR
} from "~/store/room/roomType";
import {
  SHOW_ALERT_MAX_SPECIALIST,
  HIDE_ALERT_MAX_SPECIALIST
} from "~/store/dateAndSpecialist/dateAndSpecialistTypes";

const initialState = {
  loading: false,
  data: [],
  selectedRoomAndDoctor: { id: 0 },
  pickTimeListByRoomAndDoctor: [],
  pickTimeLoading: false,
  selectedTime: { id: 0 },
  selectedBHYT: { id: -1 },
  isModalPickTime: false,
  errors: {},
  messageChooseTimeAndBHYT: "",
  /* ---- */
  sumaryInfo: [],
  redirectToConfirmInfo: false,
  alertMaxSpecialist: false,
  schedule_id: 0
};

export default function doctorAndTime(state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST_UMC_ROOM_LIST:
      return {
        ...state,
        loading: true
      };
    case REQUEST_UMC_ROOM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.data]
      };
    case REQUEST_UMC_ROOM_LIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: { ...action.errors }
      };
    case SELECTED_ROOM_AND_DOCTOR:
      return {
        ...state,
        selectedRoomAndDoctor: { ...action.room },
        isModalPickTime: true,
        pickTimeLoading: true,
        messageChooseTimeAndBHYT: ""
      };
    case SELECTED_ROOM_AND_DOCTOR_SUCCESS:
      return {
        ...state,
        pickTimeListByRoomAndDoctor: [...action.data],
        pickTimeLoading: false
      };
    case SELECTED_ROOM_AND_DOCTOR_FAIL:
      return {
        ...state,
        errors: { ...action.errors },
        pickTimeLoading: false
      };
    case REQUEST_TIME_SLOT_IN_DOCTOR_FLOW:
      return {
        ...state,
        pickTimeLoading: true
      };
    case GET_DOCTOR_TIME_SLOT_REQUEST:
      return {
        ...state,
        selectedRoomAndDoctor: { ...action.room },
        isModalPickTime: true
      };
    case GET_DOCTOR_TIME_SLOT_SUCCESS:
      /*
          Minh Anh trả về object
          UMC trả về array
          --> không biết sau này bệnh viện khác thì sao - hic hic
      */
      if (Array.isArray(action.data)) {
        return {
          ...state,
          pickTimeListByRoomAndDoctor: [...action.data],
          pickTimeLoading: false
        };
      }
      return {
        ...state,
        pickTimeListByRoomAndDoctor: [...action.data.data],
        schedule_id: action.data.schedule_id,
        pickTimeLoading: false
      };
    case GET_DOCTOR_TIME_SLOT_FAILURE:
      return {
        ...state,
        errors: { ...action.errors },
        pickTimeLoading: false
      };
    case HIDE_MODAL_PICK_TIME:
      return {
        ...state,
        isModalPickTime: false,
        selectedRoomAndDoctor: {
          id: 0
        },
        selectedBHYT: {
          id: -1
        },
        selectedTime: { id: 0 },
        messageChooseTimeAndBHYT: ""
      };
    case SELECTED_TIME:
      return {
        ...state,
        selectedTime: { ...action.time }
      };
    case SELECTED_BHYT:
      return {
        ...state,
        selectedBHYT: { ...action.info }
      };
    case RESET_REDIRECT_TO_CONFIRM_INFO:
      return {
        ...state,
        redirectToConfirmInfo: false
      };
    case SUBMIT_DOCTOR_AND_TIME: {
      const {
        dateAndSpecialist: { selectedSpecialist, selectedDate }
      } = action;
      return {
        ...state,
        redirectToConfirmInfo: true,
        isModalPickTime: false,
        selectedRoomAndDoctor: { id: 0 },
        selectedTime: { ...state.selectedTime },
        selectedBHYT: { id: -1 },
        sumaryInfo: [
          ...state.sumaryInfo,
          {
            selectedRoomAndDoctor: {
              ...state.selectedRoomAndDoctor,
              id: state.selectedTime.room_id
            },
            selectedTime: { ...state.selectedTime },
            selectedBHYT: { ...state.selectedBHYT },
            selectedSpecialist,
            selectedDate
          }
        ]
      };
    }

    case REMOVE_DOCTOR_AND_TIME: {
      const copyArray = [...state.sumaryInfo];
      const index = action.index;
      copyArray.splice(index, 1);
      return {
        ...state,
        sumaryInfo: copyArray
      };
    }

    case SHOW_MESSAGE_ERROR_CHOOSE_TIME_AND_BHYT:
      return {
        ...state,
        messageChooseTimeAndBHYT: action.message
      };
    case RESET_ALL_PROPS_DOCTOR_AND_TIME:
      return {
        ...state,
        ...initialState
      };
    case SHOW_ALERT_MAX_SPECIALIST:
      return {
        ...state,
        alertMaxSpecialist: true
      };
    case HIDE_ALERT_MAX_SPECIALIST:
      return {
        ...state,
        alertMaxSpecialist: false
      };
    case RESET_SELECTED_TIME_AND_BHYT:
      return {
        ...state,
        selectedBHYT: {
          id: -1
        },
        selectedTime: { id: 0 },
        messageChooseTimeAndBHYT: ""
      };

    case RESET_SELECTED_DOCTOR: {
      return {
        ...state,
        selectedRoomAndDoctor: { id: 0 }
      };
    }

    default:
      return state;
  }
}
